<template>
  <section class="wrapper">
    <div class="logo"><img src="../../assets/img/wc-erp-logo.png" alt=""></div>
    <h1 class="title">登录网书智能ERP系统</h1>
    <van-tabs line-height="1" shrink>
      <van-tab title="账号密码登录">
        <van-form class="mt10" @submit="login">
          <van-field
            v-model="loginForm.loginName"
            label="用户名"
            placeholder="用户名"
            :rules="[{ required: true, message: '请填写用户名' }]"
          />
          <van-field
            class="mt10"
            v-model="loginForm.passWd"
            type="password"
            name="密码"
            label="密码"
            placeholder="密码"
            :rules="[{ required: true, message: '请填写密码' }]"
          />
          <van-field
            class="mt10"
            v-model="loginForm.validate"
            name="验证码"
            label="验证码"
            placeholder="验证码"
            :rules="[{ required: true, message: '请填写验证码' }]"
          >
            <template #button>
              <van-image width="56" :src="validateCodeImgUrl" @click="desCodeSend"/>
            </template>
          </van-field>
          <div style="margin: 16px;">
            <van-button block type="primary" native-type="submit">确认登录</van-button>
          </div>
          <div class="info">
            <van-checkbox v-model="checked" shape="square" icon-size="16px">我同意<span class="link">服务条款</span>
            </van-checkbox>
            <span class="ml5 link" @click="register">立即注册</span><i class="iconfont iconfont-right-copy"/>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
  </section>
</template>
<script>
  import {getValidCodeFun, getValidateCodeFun,initUserCompanyApi} from '@/api/common'
  import {getActivateUser,loginFun} from '@/api/login'
  import {getUrlParam} from "@/utils/utitiles"

  export default {
    name: "login",
    data() {
      return {
        checked: true,
        validateCodeImgUrl: '',//验证码图片地址
        loginForm: {
          loginName: '',
          passWd: '',
          companyGuid:'',
          validate: '',
          DESEncryptValidCode: '',
          SystemType:0
        },
        loginInfo:this.getCookie("LoginInfo")
      };
    },
    //已挂载，在模板渲染成html后调用，通常是初始化页面完成后，再对html的dom节点进行一些操作
    mounted() {
      this.removeCookie("UserInfo");
      this.removeCookie("CompanyInfo");
      this.getLoginUser();
      this.desCodeSend();
    },
    methods: {
      //读取参数赋值给表单
      async getLoginUser() {
        let guid = getUrlParam("guid");
        if (guid && guid !== null && guid !== "") {
          let params = {
            guid: guid
          };
          let response = await getActivateUser(params);
          if (response.success) {
            this.$set(this.loginForm, "loginName", response.LoginName);
          }
        }
      },
      //获取加密的验证码,有了这个码才可以请求图片验证码
      async desCodeSend() {
        let response = await getValidCodeFun();
        if (response.success) {
          this.loginForm.DESEncryptValidCode = response.result;
          this.getValidateCode(response.result)
        }
      },
      //获取验证码图片
      async getValidateCode(code) {
        const params = {
          code
        };
        let response = await getValidateCodeFun(params);
        if (response.success) {
          const bufferUrl = btoa(new Uint8Array(response.data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
          this.validateCodeImgUrl = 'data:image/png;base64,' + bufferUrl;
        }
      },
      //提交登录
      async login() {
        let params = {
          ...this.loginForm
        };
        let response = await loginFun(params);
        if (response.success) {
          if (response.code === "0000") {
            this.setCookie("UserInfo", {
              U_GUID: response.result.U_GUID,
              LoginName: response.result.LoginName,
              TelName: response.result.TelName,
              NickName: response.result.NickName,
              FirstName: response.result.FirstName,
              LastName: response.result.LastName
            });
            //判断是否有数据，如果有数据说明是有传参的
            if (this.loginInfo && this.loginInfo != null) {
              //跳转到待审批页面
              this.selectCompany(this.loginInfo.companyId, this.loginInfo.TargetUrl, {
                guid: this.loginInfo.ApprovalGUID
              });
              return;
            }
            this.$router.push({path: '/company'});
            return;
          }
          this.$toast.fail(response.msg);
          await this.desCodeSend();
          return;
        }
      },
      //选择公司
      async selectCompany(cGuid,url,query) {
        let userInfo = this.getCookie("UserInfo");
        let params = {
          cGuid: cGuid,
          uGuid: userInfo.U_GUID,
          userName: userInfo.TelName || userInfo.LoginName
        }
        let response = await initUserCompanyApi(params);
        if (response.success) {
          if (response.code === "0000") {
            this.setCookie("CompanyInfo", {
              companyId: response.result.CurrentCompanyGuid,
              companyName: response.result.Name || response.result.ChineseFullName,
              loginDate: response.loginDate,
              dateFormat:response.dateFormat,
              Currency:response.result.Currency,
              enterDate: this.moment(response.result.EnterDate).format('YYYY/MM/DD HH:mm:ss') + '(UTC+8)'
            });
            this.removeCookie('LoginInfo');
            this.$router.push({path:url,query:query});
          } else {
            this.$toast.fail("公司初始化数据失败");
          }
        }
      },
      go() {
        this.$router.push({path: "/home"})
      },
      register() {
        this.$router.push({path: '/register'})
      },
    },
  }
</script>
<style lang="less" scoped>
  .wrapper {
    background: white;

    .logo {
      padding: 1rem;

      img {
        width: 70%;
      }
    }

    .title {
      text-align: center;
      padding: 2rem 0;
      background: white;
    }

    .info {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      font-size: 1.4rem;
      padding: 0 1rem;
      color: #ccc;
      height: 2rem;
      line-height: 2rem;

      .link {
        color: #00a1bb;
        display: inline-block;
      }
    }

    ::v-deep.van-tab--active {
      flex: .3;
    }

    ::v-deep.van-tabs__line {
      width: 6rem;
    }

    ::v-deep.van-button{
      background:#1fb1c4
    }
  }
</style>
